<div class="component-container flex flex-col justify-center items-center">
  <div class="display-section flex flex-col justify-center items-center">
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
             md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          First Name
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['firstName']"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="firstName"
          maxLength="{{validation.user.firstName.length.max}}"
          placeholder="First Name"
          type="small"
        >
        </app-text-input>
      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Last Name
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['lastName']"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="lastName"
          maxLength="{{validation.user.lastName.length.max}}"
          placeholder="Last Name"
          type="small"
        >
        </app-text-input>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
             md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Email
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['email']"
          [maxLength]="validation.email.length.max"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="email"
          placeholder="user@mail.com"
          type="small"
        ></app-text-input>
      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Username
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['username']"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="username"
          placeholder="Username"
          type="small"
        >
        </app-text-input>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
             md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Date of Birth
        </div>
        <app-date-picker
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['dob']"
          [max]="maxDobDate"
          [min]="minDobDate"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="dob"
          placeholder="MM/DD/YYYY"
          type="small"
        ></app-date-picker>
      </div>

      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Gender
        </div>
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['gender']"
          [loading]="genderInfoLoading"
          [options]="genderDropdownOptions"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="gender"
          placeholder="Select one"
          type="small"
        />
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
             md:gap-[2.4rem]"
    >
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Role
        </div>
        <app-text-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['role']"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="role"
          placeholder="Role"
          type="small"
        >
        </app-text-input>
      </div>
      <div class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Phone Number
        </div>
        <app-phone-number-input
          (checkForErrors)="checkForErrors($event)"
          (handleSuffixClick)="editPhoneNumber()"
          [error]="errorMessages['phoneNumber']"
          [parentFormGroup]="form"
          [suffixIcon]="'edit'"
          class="value w-3/5"
          controlName="phoneNumber"
          placeholder="Phone Number"
          type="small"
        ></app-phone-number-input>
      </div>
    </div>
    <div
      *ngIf="userDetails['role'] != roles['superAdmin']"
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem] h-[5.6rem]"
    >
      <div
        *ngIf="userDetails['role'] != roles['superAdmin']"
        class="sub-row w-full md:w-1/2 flex flex-row justify-start items-start pt-[0.9rem] gap-[2rem] md:gap-[1rem] h-[5.6rem]"
      >
        <div class="hipaa-consent-label w-2/5 ">
          Consent form
        </div>
        <div class="value w-3/5">
          <span
            (click)="hippaConsentClicked()"
            [class.link]="userDetails['consentDate']"
          >
          {{ userDetails['consentDate'] ? 'View' : 'Not Completed' }}
           </span>
          <span
            (click)="triggerNotification('hippaConsent')"
            *ngIf="!userDetails?.consentDate && loggedInUserRole !=
            roles['adult'] && loggedInUserRole != roles['participant'] &&
            loggedInUserRole < userDetails?.role"
            class="link reminder-link"
          >
         Send Reminder
           </span>
        </div>
      </div>

      <div *ngIf="userDetails['role'] === roles['participant']"
           class="sub-row w-full md:w-1/2 flex flex-row justify-start items-start pt-[0.9rem] gap-[2rem] md:gap-[1rem] h-[5.6rem]"
      >
        <div class="hipaa-assent-label w-2/5">
          Assent
        </div>
        <div class="value w-3/5">
          <span
            (click)="userDetails['assentDate'] ? hippaAssentClicked() : {}"
            [class.link]="userDetails['assentDate']"
          >
          {{ userDetails['assentDate'] ? 'View' : 'Not Completed' }}
          </span>
          <span
            (click)="triggerNotification('hippaAssent')"
            *ngIf="!userDetails?.assentDate && loggedInUserRole !=
            roles['adult'] && loggedInUserRole != roles['participant'] &&
            loggedInUserRole < userDetails?.role"
            class="link reminder-link"
          >
         Send Reminder
           </span>
        </div>
      </div>
    </div>
    <div
      class="row flex flex-col md:flex-row
           justify-start items-center
            gap-y-[1rem] md:gap-[2.4rem]"
    >
      <div
        class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5">
          Status
        </div>
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['userStatus']"
          [loading]="userStatusLoading"
          [options]="userStatusDropdownOptions"
          [parentFormGroup]="form"
          class="value w-3/5"
          controlName="userStatus"
          placeholder="Select one"
          type="small"
        />
      </div>
      <div
        *ngIf="userDetails['role'] === roles['participant']"
        class="sub-row w-full md:w-1/2 flex flex-row justify-start items-center gap-[2rem] md:gap-[1rem]"
      >
        <div class="label w-2/5 place-self-center mt-[2rem]">
          Avatar
        </div>
        <app-avatar-panel
          (handleClick)="selectAvatar($event)"
          [selectedAvtar]="userDetails['avatar']"
          class="avatar-panel value min-w-3/5"
        >
        </app-avatar-panel>
      </div>
    </div>
  </div>
  <div
    class="action-section flex flex-row
           justify-end items-center space-x-[1rem]"
  >
    <app-icon
      (click)="deleteUser()"
      *ngIf="!(loggedInUserRole === roles.adult && selectedUserRole ===
      roles.participant) && hasUserId"
      [svgIcon]="'delete'"
      class="delete-icon cursor-pointer"
    >
    </app-icon>
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!form.dirty"
      class="save-btn w-[8rem]"
      type="small"
    >
      Save
    </app-primary-button>
    <app-primary-button
      (handleClick)="close()"
      class="close-btn w-[8rem]"
      type="small"
    >
      Close
    </app-primary-button>
  </div>
</div>
